import { AbstractControl, FormGroup } from "@angular/forms";

export function matchingPasswords(passwordKey: string, confirmPasswordKey: string): any {
    return (group: FormGroup): any => {
        let password = group.controls[passwordKey];
        let confirmPassword = group.controls[confirmPasswordKey];
        if (password.value !== confirmPassword.value) {
            confirmPassword.setErrors({ mismatchedPasswords: true });
        } else {
            confirmPassword.setErrors(null);
        }
    }
}

export function validateEmail(email: any) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(email).toLowerCase());
}

export function ValidateEmailField(control: AbstractControl): { [key: string]: any } | null {
    if (validateEmail(control.value) == false) {
        return { 'email': true };
    }
    return null;
}

export function matchingEmails(emailKeys: string, confirmEmailKey: string): any {
    return (group: FormGroup): any => {
        let email = group.controls[emailKeys];
        let confirmEmail = group.controls[confirmEmailKey];
        if (email.value !== confirmEmail.value) {
            confirmEmail.setErrors({ mismatchedEmails: true });
        } else {
            confirmEmail.setErrors(null);
        }
    }
}
